export default __webpack_public_path__ + "static/media/solution-beagile.f1b8f617.jpg";